<template>
  <div
    v-if="!hardSet()">
    <v-form
      :key="0">
      <v-select
        :items="genderList"
        :label="`Please list ` + (modifyIndex === 0 ? 'your' : 'their') + ` Sex`"
        v-model="modifyData[modifyIndex].gender"
        dense
        :readonly='hardSet()'
        outlined></v-select>
    </v-form>
  </div>
</template>

<script>
  import { mapFields } from "vuex-map-fields";
  export default {
    props: {
      modifyData: Array,
      modifyIndex: Number
    },
    mounted () {
    },
    methods: {
      hardSet() {
        return [
          "mother",
          "maternal aunt",
          "maternal uncle",
          "maternal grandfather",
          "maternal grandmother",
          "father",
          "paternal aunt",
          "paternal uncle",
          "paternal grandfather",
          "paternal grandmother",
        ].includes(this.modifyData[this.modifyIndex].relationship);
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapFields("patientQuestion", [
        "dataModel",
        "genderList",
      ])
    }
  };
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
